import {
    createContext
} from 'react';

export const DashboardsContext = createContext<any | null>(null);